import { Prop } from 'vue-property-decorator'
import { VueWizard } from "@/vue-wizard";
import {fromEvent, Subscription} from "rxjs";
import {countryPhoneCodes} from "@/assets/plugins/country-phone-codes";
import {managementApiUrl} from "@/config";
import axios, {AxiosResponse} from "axios";
import {configAuth} from "@/assets/helpers/getAuthHeaders";
import $ from "jquery";
import Swal from "sweetalert2";

export class PreRegisterTemplate extends VueWizard {

    public preRegisterData: any;
    public reCaptchaSiteKey: string;
    public lockPasteSubscription: Subscription | null;
    public loading: boolean;
    @Prop({default: 'None'}) readonly sourceReference!: string;

    constructor() {
        super();
        this.preRegisterData = {...this.initialPreRegisterData};
        this.reCaptchaSiteKey = '';
        this.lockPasteSubscription = null;
        this.loading = false;
    }

    get formattedCountryPhoneCodes() {
        return countryPhoneCodes.filter(
            (countryPhoneCode) => countryPhoneCode.dial_code
        ).sort(
            (a, b) => {
                return Number.parseInt(
                    a.dial_code!.replace("+", "").replace(" ", "")
                ) - Number.parseInt(
                    b.dial_code!.replace("+", "").replace(" ", "")
                )
            }
        );
    }

    get isPhoneCountryCode(): boolean {
        return this.preRegisterData.phoneCountryCode.toString().length > 0
    }

    get isPhoneNumber(): boolean {
        return this.preRegisterData.phoneNumber.toString().length > 0
    }

    get isEmail(): boolean {
        return this.preRegisterData.email.toString().length > 0
    }

    get isReCaptchaToken(): boolean {
        return this.preRegisterData.captchaToken.toString().length > 0
    }

    get equalPhoneNumbers(): boolean {
        const {phoneNumberConfirm, phoneNumber} = this.preRegisterData
        return !this.isPhoneNumber
            || phoneNumberConfirm.toString().length <= 0
            || phoneNumber.toString() === phoneNumberConfirm.toString()
    }

    get equalEmails(): boolean {
        const {emailConfirm, email} = this.preRegisterData
        return !this.isEmail
            || emailConfirm.toString().length <= 0
            || email.toString() === emailConfirm.toString()
    }

     get isTypeOfDocument(): boolean {
        return this.preRegisterData.typeOfDocument.toString().length > 0
    }

    get initialPreRegisterData() {
        return {
            phoneCountryCode: "+57",
            phoneNumber: "",
            phoneNumberConfirm: "",
            email: "",
            emailConfirm: "",
            typeOfDocument: "CC",
            documentNumber: "",
            companyName: "ACME",
            checked: false,
            captchaToken: ''
        }
    }

    async loadReCaptchaSiteKey() {
        const url = `${managementApiUrl}/params/recaptcha`;
        const res = await axios.get(url,configAuth);
        this.reCaptchaSiteKey = res.data.websiteKey;
    }

    lockPasteOnNoPasteInputs() {
        this.lockPasteSubscription = fromEvent($('.no-paste'), 'paste').subscribe(
            (event) => event.preventDefault()
        )
    }

    verifyCaptcha(token: any) {
        this.preRegisterData.captchaToken = token;
    }

    expiredCaptcha() {
        const swalCancelButtons = <any>document.getElementsByClassName("swal2-cancel swal2-styled")
        if (swalCancelButtons && Array.isArray(swalCancelButtons) && swalCancelButtons.length > 0) {
            swalCancelButtons.forEach((button) => button.click());
        }
    }

    async resetReCaptcha(){
        this.reCaptchaSiteKey = ""
        this.preRegisterData.captchaToken = ""
        await this.loadReCaptchaSiteKey()
    }

    fireResultAlert(title: string, icon: "success" | "error" | "warning" | "info" | "question" | undefined, html: string) {
        return Swal.fire({
            title,
            heightAuto: false,
            icon,
            html,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: false
        });
    }

    async doPreRegister() {
        await Swal.fire({
            title: '¿Está seguro de enviar estos datos?',
            html: `<span>
                    Número telefónico: <b>${this.preRegisterData.phoneCountryCode}${this.preRegisterData.phoneNumber}</b>
                   </span>
                   <br/>
                   <span>
                    Correo electrónico: <b>${this.preRegisterData.email}</b>
                   </span>`,
            icon: 'warning',
            heightAuto: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Realizar Pre registro',
            cancelButtonText: 'Cancelar'
        }).then((result): any => {
            this.loading = true;
            if (result.isConfirmed) {
                const formattedPhoneCode = this.preRegisterData.phoneCountryCode.replace('+', '');
                return axios.post(
                    `${managementApiUrl}/registry`,
                    { ...this.preRegisterData, phoneCountryCode: formattedPhoneCode, urlParameters: { sourceReference: this.sourceReference }}
                )
            }
        }).then(async (response: AxiosResponse) => {
            (this.$refs.recaptcha as any).reset();
            if(response && response.data) {
                if (!response.data.message) {
                    await this.fireResultAlert(
                        "Pre registro exitoso",
                        "success",
                        `Se ha enviado un correo electrónico a <b>${this.preRegisterData.email}</b>`
                    )
                } else {
                    await this.fireResultAlert(
                        "Correo de Pre registro Reenviado",
                        "warning",
                        `Se ha reenviado el correo electrónico de pre registro a <b>${this.preRegisterData.email}</b>`
                    )
                }
                await this.$router.push({name : "pre-register-thanks"})
                this.preRegisterData = {...this.initialPreRegisterData};
            }
        }).catch(async (error) => {
            await this.resetReCaptcha()
            await this.fireResultAlert(
                "¡Error al realizar el pre registro!",
                "error",
                error && error.response && error.response.data && error.response.data.error
                    ? `No se ha podido realizar el pre registro, razón: <b>${error.response.data.error}</b>`
                    : `Error al realizar el pre registro, por favor intente de nuevo`
            )
        }).finally(() => this.loading = false)
    }

}